module.exports = __webpack_public_path__ + "img/icon-bookmarked.331323ec.svg";